import { Controller } from "@hotwired/stimulus"

// Rotates through trading platform names with a vertical slide animation
export default class extends Controller {
  static targets = ["text"]
  static values = {
    platforms: { type: Array, default: ["TradingView", "AmiBroker", "Optuma", "TC2000", "MetaStock", "ProRealTime"] },
    interval: { type: Number, default: 4000 }
  }

  connect() {
    this.currentIndex = 0
    this.isAnimating = false
    this.startRotation()
  }

  disconnect() {
    this.stopRotation()
  }

  startRotation() {
    this.timer = setInterval(() => this.rotate(), this.intervalValue)
  }

  stopRotation() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  rotate() {
    if (this.isAnimating) return
    this.isAnimating = true

    const textEl = this.textTarget

    // Slide out (up)
    textEl.classList.add("sliding-out")

    setTimeout(() => {
      // Update to next platform
      this.currentIndex = (this.currentIndex + 1) % this.platformsValue.length
      textEl.textContent = this.platformsValue[this.currentIndex]

      // Reset position for slide in
      textEl.classList.remove("sliding-out")
      textEl.classList.add("sliding-in")

      // Small delay then animate in
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          textEl.classList.remove("sliding-in")
          textEl.classList.add("sliding-visible")

          setTimeout(() => {
            textEl.classList.remove("sliding-visible")
            this.isAnimating = false
          }, 300)
        })
      })
    }, 300)
  }
}
